// Icônes dessinées, trait 1.5, héritent de la couleur du texte.
type P = { className?: string };

const base = 'inline-block shrink-0 fill-none stroke-current';

/** Flèche ; `dir` oriente la pointe (droite par défaut). */
export function Arrow({ className = 'h-[0.9em] w-[0.9em]', dir = 'right' }: P & { dir?: 'right' | 'left' | 'down' | 'up-right' }) {
    const rotate = { right: 0, left: 180, down: 90, 'up-right': -45 }[dir];
    return (
        <svg viewBox="0 0 16 16" aria-hidden data-arrow={dir} className={`${base} ${className}`} style={{ rotate: `${rotate}deg` }} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 8h12M9 3l5 5-5 5" />
        </svg>
    );
}

/** Feuille de vigne stylisée, séparateur du bandeau. */
export function Leaf({ className = 'h-[0.6em] w-[0.6em]' }: P) {
    return (
        <svg viewBox="0 0 16 16" aria-hidden className={`${base} ${className}`} strokeWidth={1.5} strokeLinejoin="round">
            <path d="M8 15V7M8 1c2.5 2 5 2.5 6 2.5-.3 4-2.5 7-6 8.5C4.5 10.5 2.3 7.5 2 3.5 3 3.5 5.5 3 8 1Z" />
        </svg>
    );
}
